import React, { useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import {
  CPopover,
  CWidgetDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CDropdown,
  CBadge,
  CWidgetIcon,
  CImg,
} from "@coreui/react";

import CIcon from "@coreui/icons-react";
import ProfilePopOver from "./components/ProfilePopover";
import Storage from "../Storage/AuthSession.js";
import { apiClient } from "../Storage/ApiClient.js";

const TheHeaderDropdown = () => {
  const history = useHistory();
  const [toLoginPage, setToLoginPage] = useState(false);
  const [url, setUrl] = useState(
    Storage.isCorporate()
      ? "corporate/navigation/summery"
      : "navigation/summery"
  );
  const [data, setData] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userData"));

  function onLogoutHandler() {
    Storage.logOut();
    history.push("/auth/login");
    setToLoginPage(true);
  }
  useEffect(() => {
    const fetchData = async () => {
      apiClient
        .get(url)
        .then((response) => {
          setData(response.data.data);
        })
        .catch(function (error) {
          if (error.response) {
            // client received an error response (5xx, 4xx)
          } else if (error.request) {
            // client never received a response, or request never left
          } else {
            // anything else
          }
        });
    };
    fetchData();
  }, [url]);

  return (
    <>
      {toLoginPage ? <Redirect to="/login" /> : null}
      {Storage.isCorporate() ? (
        <div>
          <CWidgetDropdown
            color="primary"
            text={
              userData ? userData.data.user.customer.employer.employer_name : ""
            }
          >
            <CDropdown
              inNav
              className="c-header-nav-items mx-2"
              direction="down"
            >
              <CDropdownToggle className="c-header-nav-link" caret={false}>
                <div>
                  <CIcon
                    name={"cilSettings"}
                    size={"lg"}
                    style={{ color: "white", fontSize: "1.5em" }}
                  />
                </div>
              </CDropdownToggle>
              <CDropdownMenu className="pt-0" placement="bottom-end">
                <CDropdownItem>
                  <CIcon name="cil-user" className="mfe-2" />
                  {userData ? userData.data.user.customer.full_name : ""}
                </CDropdownItem>
                <CDropdownItem onClick={onLogoutHandler}>
                  <CIcon name="cil-lock-locked" className="mfe-2" />
                  Logout
                </CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          </CWidgetDropdown>
        </div>
      ) : (
        <CWidgetDropdown
          color="primary"
          header={"Ksh. " + data.totalInterest}
          style={{ backgroundColor: "#E7C724" }}
          text={"Actual Ksh ." + data.earnedInterest}
        >
          <CDropdown inNav className="c-header-nav-items mx-2" direction="down">
            <CDropdownToggle className="c-header-nav-link" caret={false}>
              <div>
                <CIcon
                  name={"cilSettings"}
                  size={"lg"}
                  style={{ color: "white", fontSize: "1.5em" }}
                />
              </div>
            </CDropdownToggle>
            <CDropdownMenu className="pt-0" placement="bottom-end">
              <CDropdownItem>
                <CIcon name="cil-user" className="mfe-2" />
                {userData ? userData.data.user.customer.full_name : ""}
              </CDropdownItem>
              <CDropdownItem>
                <CIcon name="cil-settings" className="mfe-2" />
                Account Settings
              </CDropdownItem>
              <CDropdownItem onClick={onLogoutHandler}>
                <CIcon name="cil-lock-locked" className="mfe-2" />
                Logout
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </CWidgetDropdown>
      )}
    </>
  );
};

export default TheHeaderDropdown;
